module.exports = __webpack_public_path__ + "assets/img/trash-2.7540df20.svg";